<template>
<div>
    <b-table 
      striped 
      hover 
      selectable 
      select-mode="single" 
      @row-selected="onRowSelected" 
      :items="items" 
      :fields="fields" 
      :filter="filter"
      @filtered="onFiltered"
      :per-page="perPage"
      :current-page="currentPage">
      <template v-slot:cell(userCnt)="data">
          <b-badge pill variant="info" style='width: 30px; padding: 5px'>{{ data.value }}</b-badge>
      </template>
    </b-table>



    <TablePagination 
      :total-rows="totalRows" 
      :per-page="perPage" 
      @pageChange="onPageChange">
    </TablePagination>
</div>
</template>

<script>

import TablePagination from '@/components/Misc/TablePagination'

export default {
  components: { TablePagination },
  props: ['filter'],
  data() {
      return {
        perPage: 15,
        currentPage: 1,
        filteredRows: 0,
        fields: [
          { key: "id", label: this.$t('users.id') },
          { key: "description", label: this.$t('users.description') },
          { key: "userCnt", label: this.$t('nav.system.users') }          
        ]
      }
  },
  computed: {
    items() {
      var userCnts = new Map();
      var users = this.$store.state.userDataHandler.users.list;
      users.forEach(function (user) {
          if(user.usergroups) {
            user.usergroups.forEach(function (usergroup) {
              let cnt = userCnts.get(usergroup.id);
              userCnts.set(usergroup.id, cnt ? ++cnt : 1);
            });
          }
      });

      var groups =  this.$store.state.userDataHandler.userGroups.list;
      groups.forEach(function (group) {
          let cnt = userCnts.get(group.id);
          group.userCnt = cnt ? cnt : 0;
      });

      return groups;
    },
    totalRows() {
        return this.filteredRows ? this.filteredRows : (this.items ? this.items.length : 0);
    }               
  },
  created() {
      this.$store.dispatch('userDataHandler/getUsers');
      this.$store.dispatch('userDataHandler/getUserGroups');
  },
  methods: {
    onRowSelected(items) {
      this.$emit('selectItem', items[0]);
    },
    onFiltered(filteredItems) {
      this.filteredRows = filteredItems.length;
      this.currentPage = 1
    },
    onPageChange(page){
      this.currentPage = page
    }
  }
}
</script>
